import * as Yup from 'yup';
import { getCarrierShape, Props } from 'validators/Common/baseCarrierValidator';

export class CreateCarrierValidator {
  constructor(protected readonly props: Props) {}

  public get schema() {
    return Yup.object().shape({
      ...getCarrierShape(this.props),
    });
  }
}
